import React from 'react'

import { Container } from 'rsuite'
import AppSidebar from '@components/parts/AppSidebar'
import MobileMenu from '@components/parts/MobileMenu'
import PageContentContainer from './PageContentContainer'
import { useReactiveVar } from '@apollo/client'
import { sidebarExpandedVar } from '@@partner:graphql/initial-data'
import { usePartner } from '@@partner:helpers/hooks/auth'

import { useFetchOrdersByStatus } from '@@partner:graphql/query/order/ordersByStatus.gql'

import './PageWithSidebar.scss'
import AppHeaderBar from '@components/parts/AppHeaderBar'


const PageWithSidebar: React.FC = ({ children }) => {
  const isExpanded = useReactiveVar(sidebarExpandedVar)
  const { partnerInfo, currentBrand } = usePartner()

  return (
    <div className="PageWithSidebar">
      <AppHeaderBar />
      <Container>
        <AppSidebar />
        <MobileMenu />
        <Container 
          className="PageWithSidebar__MainContainer"
          style={{ marginLeft: isExpanded ? 260 : 56 }}
        >
          <PageContentContainer>{children}</PageContentContainer>
        </Container>
      </Container>
    </div>
  )
}

export default PageWithSidebar
